import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations, useTexture } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import useGame from '../stores/useGame'
import * as THREE from 'three'

export function MPTModule(props) {

    const group = useRef()
    const { nodes, materials, animations } = useGLTF('/MPT_Module.glb')
    const { actions } = useAnimations(animations, group)
    const thruster = useGame((state) => state.thruster)

    const hetAO = useTexture('./textures/MPT_Thruster_AO.webp')
      hetAO.flipY = false
      materials.MPT_Thruster.aoMap = hetAO
      materials.MPT_Thruster.aoMapIntensity = 1

    const state = useThree()
    const phase = useGame((state) => state.phase)

    const highlight = useGame((state) => state.highlight)

    const highlightMaterial = new THREE.MeshStandardMaterial({
      color: 'red',
      emissive: 'red',
      emissiveIntensity: 0.25,
    })

    useEffect(() => {
    if(state.size.width > 950)

    {
        if (highlight === 'h_ps') { state.scene.traverse(obj => { if(obj.name.includes('S_PS')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_fd') { state.scene.traverse(obj => { if(obj.name.includes('S_FD')) { obj.material = highlightMaterial } }) }

        if (highlight === 'h_pr') { state.scene.traverse(obj => { if(obj.name.includes('S_PR')) { obj.material = highlightMaterial } }) }
        
        if (highlight === 'null') 
            {
            state.scene.traverse(obj => {

                if(obj.name.includes('MPT_S_PS') | obj.name.includes('MPT_S_FD') | obj.name.includes('MPT_S_PR'))
                {
                    obj.material = materials.MPT_Thruster
                }
            })
            }
    }
    },[highlight])

    useEffect(() => {

        if (phase === 'zoomed') 
            {
                actions['MPT_Animation'].loop = false
                actions['MPT_Animation'].clampWhenFinished = true
                actions['MPT_Animation'].timeScale = 1
                actions['MPT_Animation'].repetitions = 0
                actions['MPT_Animation'].paused = false
                actions['MPT_Animation'].play()
            }
    
        if (phase != 'zoomed') 
            {
                actions['MPT_Animation'].loop = false
                actions['MPT_Animation'].clampWhenFinished = true
                actions['MPT_Animation'].timeScale = -1
                actions['MPT_Animation'].repetitions = 0
                actions['MPT_Animation'].paused = false
                actions['MPT_Animation'].play()
            }
        }, [phase, actions])

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="MPT_Animator">
          <group name="MPT_POI_C_CP" position={[0.491, 0.080, -0.015]} />
          <group name="MPT_POI_C_FD1" position={[0.504, -0.105, -0.092]} />
          <group name="MPT_POI_C_FD2" position={[0.508, 0.095, 0.018]} />
          <group name="MPT_POI_C_IV1" position={[0.483, -0.095, -0.001]} />
          <group name="MPT_POI_C_IV2" position={[0.484, 0.09, -0.044]} />
          <group name="MPT_POI_C_NZ" position={[0.498, -0.025, 0]} />
          <group name="MPT_POI_C_PR1" position={[0.491, -0.094, 0.071]} />
          <group name="MPT_POI_C_PR2" position={[0.491, 0.11, -0.068]} />
          <group name="MPT_POI_C_SF1" position={[0.488, -0.098, -0.043]} />
          <group name="MPT_POI_C_SF2" position={[0.473, 0.061, -0.069]} />
          <group name="MPT_POI_C_SS" position={[0.488, -0.011, 0.086]} />
          <group name="MPT_POI_C_TO" position={[0.491, 0.015, 0.04]} />
          <group name="MPT_POI_S_FD" position={[0.488, -0.016, 0.016]} />
          <group name="MPT_POI_S_PR" position={[0.488, 0.067, -0.011]} />
          <group name="MPT_POI_S_PS" position={[0.446, -0.05, -0.069]} />

          <group name="MPT_POS_C_CP" position={[0.445, 0.083, -0.015]} />
          <group name="MPT_POS_C_FD1" position={[0.455, -0.089, -0.113]} />
          <group name="MPT_POS_C_FD2" position={[0.451, 0.111, 0.026]} />
          <group name="MPT_POS_C_IV1" position={[0.435, -0.074, 0.002]} />
          <group name="MPT_POS_C_IV2" position={[0.435, 0.073, -0.033]} />
          <group name="MPT_POS_C_NZ" position={[0.564, 0.027, -0.033]} />
          <group name="MPT_POS_C_PR1" position={[0.444, -0.091, 0.093]} />
          <group name="MPT_POS_C_PR2" position={[0.449, 0.118, -0.086]} />
          <group name="MPT_POS_C_SF1" position={[0.446, -0.08, -0.025]} />
          <group name="MPT_POS_C_SF2" position={[0.429, 0.062, -0.047]} />
          <group name="MPT_POS_C_SS" position={[0.436, -0.021, 0.045]} />
          <group name="MPT_POS_C_TO" position={[0.448, 0.015, 0.047]} />
          <group name="MPT_POS_S_FD" position={[0.401, -0.027, 0.027]} />
          <group name="MPT_POS_S_PR" position={[0.395, 0.076, -0.024]} />
          <group name="MPT_POS_S_PS" position={[0.399, -0.053, -0.029]} />

          <group name="MPT_TAR_C_CP" position={[0.487, 0.085, -0.015]} />
          <group name="MPT_TAR_C_FD1" position={[0.504, -0.094, -0.093]} />
          <group name="MPT_TAR_C_FD2" position={[0.508, 0.085, 0.017]} />
          <group name="MPT_TAR_C_IV1" position={[0.483, -0.095, -0.001]} />
          <group name="MPT_TAR_C_IV2" position={[0.484, 0.084, -0.044]} />
          <group name="MPT_TAR_C_NZ" position={[0.547, 0.001, 0]} />
          <group name="MPT_TAR_C_PR1" position={[0.491, -0.094, 0.071]} />
          <group name="MPT_TAR_C_PR2" position={[0.491, 0.103, -0.068]} />
          <group name="MPT_TAR_C_SF1" position={[0.488, -0.094, -0.043]} />
          <group name="MPT_TAR_C_SF2" position={[0.473, 0.07, -0.068]} />
          <group name="MPT_TAR_C_SS" position={[0.488, -0.011, 0.075]} />
          <group name="MPT_TAR_C_TO" position={[0.491, 0, 0.038]} />
          <group name="MPT_TAR_S_FD" position={[0.489, -0.009, 0.03]} />
          <group name="MPT_TAR_S_PR" position={[0.488, 0.07, -0.029]} />
          <group name="MPT_TAR_S_PS" position={[0.482, -0.085, -0.044]} />

          {thruster === 'MPT' && <> 
          <mesh
            name="MPT_C_Backplate"
            castShadow
            receiveShadow
            geometry={nodes.MPT_C_Backplate.geometry}
            material={materials.MPT_Thruster}
            position={[0.518, 0, 0]}
          />
          <mesh
            name="MPT_C_Bolts"
            castShadow
            receiveShadow
            geometry={nodes.MPT_C_Bolts.geometry}
            material={materials.MPT_Thruster}
          />
          <mesh
            name="MPT_C_PowerCable"
            castShadow
            receiveShadow
            geometry={nodes.MPT_C_PowerCable.geometry}
            material={materials.MPT_Thruster}
            position={[0.499, -0.07, 0.086]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_FD_C_Box"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_Box.geometry}
            material={materials.MPT_Thruster}
            position={[0.497, -0.014, 0.088]}
          />
          <mesh
            name="MPT_S_FD_C_NZ"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_NZ.geometry}
            material={materials.MPT_Thruster}
            position={[0.525, 0, 0]}
            rotation={[0, 0, Math.PI / 2]}
          />
          <mesh
            name="MPT_S_FD_C_SS_Red"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_SS_Red.geometry}
            material={materials.MPT_Thruster}
          />
          <mesh
            name="MPT_S_FD_C_SS_White"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_SS_White.geometry}
            material={materials.MPT_Thruster}
            position={[0, -0.038, 0]}
          />
          <mesh
            name="MPT_S_FD_C_Thrustplate"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_Thrustplate.geometry}
            material={materials.MPT_Thruster}
            position={[0.508, 0, 0]}
          />
          <mesh
            name="MPT_S_FD_C_TO"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_FD_C_TO.geometry}
            material={materials['CG_Thruster.001']}
            position={[0.498, 0, 0.037]}
            rotation={[-Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_CP"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_CP.geometry}
            material={materials.MPT_Thruster}
            position={[0.495, 0.084, -0.015]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_FD2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_FD2.geometry}
            material={materials.MPT_Thruster}
            position={[0.516, 0.084, 0.017]}
          />
          <mesh
            name="MPT_S_PR_C_IV2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_IV2.geometry}
            material={materials.MPT_Thruster}
            position={[0.493, 0.084, -0.045]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_Join_1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_Join_1.geometry}
            material={materials.MPT_Thruster}
            position={[0.488, 0.084, 0.017]}
            rotation={[-Math.PI / 2, Math.PI / 2, 0]}
          />
          <mesh
            name="MPT_S_PR_C_Join_2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_Join_2.geometry}
            material={materials.MPT_Thruster}
            position={[0.487, 0.085, -0.069]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_Pipes.geometry}
            material={materials.MPT_Thruster}
          />
          <mesh
            name="MPT_S_PR_C_PR2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_PR2.geometry}
            material={materials.MPT_Thruster}
            position={[0.495, 0.098, -0.068]}
            rotation={[Math.PI, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_PressureTank"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_PressureTank.geometry}
            material={materials.MPT_Thruster}
            position={[0.49, 0.084, 0.062]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="MPT_S_PR_C_SF2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PR_C_SF2.geometry}
            material={materials.MPT_Thruster}
            position={[0.481, 0.068, -0.069]}
            rotation={[Math.PI / 2, 0, 0]}
          />
          <mesh
            name="MPT_S_PS_C_FD1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_FD1.geometry}
            material={materials.MPT_Thruster}
            position={[0.516, -0.094, -0.092]}
          />
          <mesh
            name="MPT_S_PS_C_FuelTank"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_FuelTank.geometry}
            material={materials.MPT_Thruster}
            position={[0.477, 0.007, -0.069]}
          />
          <mesh
            name="MPT_S_PS_C_IV1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_IV1.geometry}
            material={materials.MPT_Thruster}
            position={[0.496, -0.095, 0.001]}
          />
          <mesh
            name="MPT_S_PS_C_Join_1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_Join_1.geometry}
            material={materials.MPT_Thruster}
            position={[0.491, -0.095, -0.068]}
          />
          <mesh
            name="MPT_S_PS_C_Join_2"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_Join_2.geometry}
            material={materials.MPT_Thruster}
            position={[0.491, -0.094, 0.051]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            name="MPT_S_PS_C_Pipes"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_Pipes.geometry}
            material={materials.MPT_Thruster}
            position={[0, -0.007, 0]}
          />
          <mesh
            name="MPT_S_PS_C_PR1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_PR1.geometry}
            material={materials.MPT_Thruster}
            position={[0.498, -0.094, 0.066]}
          />
          <mesh
            name="MPT_S_PS_C_SF1"
            castShadow
            receiveShadow
            geometry={nodes.MPT_S_PS_C_SF1.geometry}
            material={materials.MPT_Thruster}
            position={[0.498, -0.094, -0.042]}
          /></>}
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/MPT_Module.glb')
